import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {IonContent, ModalController} from '@ionic/angular';
import {CommonService} from '../../../../../_services/common.service';
import {ToastService} from '../../../../../_services/toast.service';
import {environment} from '../../../../../../environments/environment';
import {LocalStorageService, UserService} from '../../../../../_services';
import {LoadingService} from '../../../../../_services/loading.service';


@Component({
  selector: 'app-why-report-published',
  templateUrl: './report-published.component.html',
  styleUrls: ['./report-published.component.scss'],
})
export class ReportPublishedComponent implements OnInit, OnChanges {


  @ViewChild(IonContent) content: IonContent;
  projectImg: any;
  reportObj: any;
  reportDetails: any;
  selectedProjectedObj: any;

  constructor(public router: Router,
              private commonService: CommonService,
              private spinner: LoadingService,
              private userService: UserService,
              private localStorageService: LocalStorageService,
              private toast: ToastService,
              public modalController: ModalController) {
    // this.reportObj = this.localStorageService.get('report_details');
    this.selectedProjectedObj = this.localStorageService.get('selected_project');
  }

  @Input() set report(value: boolean) {
    this.getReportDetails(value);
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnInit() {
  }

  getReportDetails(value) {
    this.spinner.show();
    this.userService.groupReports(value.title, value.address, value.location, value.projectType)
      .subscribe({
        next: (data: any) => {
          console.log(data);
          this.reportObj = data;
          this.spinner.hide();
        },
        error: err => {
          this.spinner.hide();
        }
      });
  }

  dismiss(): void {
    this.modalController.dismiss();
    this.router.navigate(['/map']);
  }

  navigateToProfile() {
    this.modalController.dismiss();
    const currentUser = this.localStorageService.get(environment.currentUser);
    if (currentUser === null) {
      const projectType = localStorage.getItem('projectType');
      this.router.navigate(['./user/auth/sign-in', projectType]);
    } else {
      this.router.navigate(['/profile', 1]);
    }
  }

  copyLink() {
    const content = 'https://mapimo.org/map';
    navigator.clipboard.writeText(content).then(() => {
      /* clipboard successfully set */
      this.toast.display('Link copied successfully');
    }, (error) => {
      this.toast.error('Failed to fetch link');
    });
  }

  feedback() {
    this.modalController.dismiss();
    this.router.navigate(['/feedback']);
  }
}

